import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useEditor } from '@splashthat/splash-cms-engine';

import TouchpointContainer, {
    GuestExperienceContainer,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';
import { useModal } from 'common/components/TouchpointEditor/contexts/ModalManager';
import { useAddElementsByUrl } from './hooks/useAddElementsByUrl';

const EditorTools = React.lazy(() => import('common/components/TouchpointEditor/components/TouchpointSidebar'));
const AddNodePopover = React.lazy(() => import('common/components/TouchpointEditor/components/AddNodePopover'));
const NodeCanvasToolsPopover = React.lazy(() =>
    import('common/components/TouchpointEditor/components/NodeCanvasToolsPopover'),
);

export default function GenericConfirmation({ portal }) {
    const editor = useEditor(({ nodes, editing }) => ({ nodes, editing }));
    const modal = useModal();

    useEffect(() => {
        if (editor.editing) {
            const rsvpModal = Object.values(editor.nodes).find((node) => node.type === 'Modal');
            rsvpModal?.id && modal.open(rsvpModal.id);
        }
    }, [editor.nodes]);

    useAddElementsByUrl(editor.nodes, editor.actions);

    return (
        <TouchpointContainer editing={editor.editing}>
            <GuestExperienceContainer $editing={editor.editing}>
                <div ref={portal} />
            </GuestExperienceContainer>
            {editor.editing && (
                <>
                    <EditorTools />
                    <AddNodePopover />
                    <NodeCanvasToolsPopover />
                </>
            )}
        </TouchpointContainer>
    );
}

GenericConfirmation.propTypes = {
    portal: PropTypes.shape({
        current: PropTypes.instanceOf(Element),
    }).isRequired,
};
